import React from 'react';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import { TopbarContainer } from '..';
import config from '../../config';

import facebookImage from '../../assets/attractrFacebook-1200x630.avif';
import twitterImage from '../../assets/attractrTwitter-600x314.avif';

import SectionHero from './SectionHero';
import SectionFeature from './SectionFeature';
import SectionInvolve from './SectionInvolve';
import SectionExpand from './SectionExpand';
import SectionBackstage from './SectionBackstage';
import SectionPlatform from './SectionPlatform';
import SectionAction from './SectionAction';

import css from './CreatorsPage.module.css';

export const CreatorsPageComponent = props => {
  const { intl, scrollingDisabled } = props;

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'CreatorsPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'CreatorsPage.schemaDescription' });
  const schemaImage = `${config.canonicalRootURL}${facebookImage}`;

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      currentPage="CreatorsPage"
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        { url: `${config.canonicalRootURL}${twitterImage}`, width: 600, height: 314 },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="CreatorsPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <SectionHero />
          <div className={css.content}>
            <SectionFeature />
            <SectionInvolve />
            <SectionExpand />
            <SectionBackstage />
            <SectionPlatform />
            <SectionAction />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

CreatorsPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from withRouter
  history: object.isRequired,
  location: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CreatorsPage = compose(
  withRouter,
  connect(mapStateToProps),
  injectIntl
)(CreatorsPageComponent);

export default CreatorsPage;
